import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { QueryString } from '@grandvisionhq/utils';
import { useRoutingContext } from '../../pages/BookAppointment/context/RoutingContext/context.js';
import LinkedAppointmentInfo$1 from './LinkedAppointmentInfo.js';

const AppointmentInfoContainer = (_param)=>{
    var { className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className"
    ]);
    const { getLabel  } = useIntl();
    const [, { queryParams , basePath , currentRoute  }] = useRoutingContext();
    const { linkedAppointmentTypeIdIsAvailable: linkedAppointmentTypeIdIsAvailable1 , alternativeAppointmentTypeIdIsAvailable: alternativeAppointmentTypeIdIsAvailable1  } = React.useMemo(()=>{
        const isWhereRoute = currentRoute === '' || currentRoute === 'where';
        const isWhenRoute = currentRoute === 'when';
        if (!isWhereRoute && !isWhenRoute) {
            // we don't want to show the component for other routes
            return {};
        }
        const linkedAppointmentTypeIdIsAvailable = !!(queryParams === null || queryParams === void 0 ? void 0 : queryParams.linkedAppointmentTypeId);
        const alternativeAppointmentTypeIdIsAvailable = !!(queryParams === null || queryParams === void 0 ? void 0 : queryParams.alternativeLinkedAppointmentTypeId);
        return {
            linkedAppointmentTypeIdIsAvailable,
            alternativeAppointmentTypeIdIsAvailable
        };
    }, [
        currentRoute,
        queryParams === null || queryParams === void 0 ? void 0 : queryParams.linkedAppointmentTypeId,
        queryParams === null || queryParams === void 0 ? void 0 : queryParams.alternativeLinkedAppointmentTypeId, 
    ]);
    const { urlToBeReplacedForLinkedAppointmentType: urlToBeReplacedForLinkedAppointmentType1 , urlToBeReplacedForAlternativeAppointmentType: urlToBeReplacedForAlternativeAppointmentType1  } = React.useMemo(()=>{
        if (!linkedAppointmentTypeIdIsAvailable1 && !alternativeAppointmentTypeIdIsAvailable1) {
            return {};
        }
        /* we dont want to keep either linkedAppointmentTypeId
        or alternativeLinkedAppointmentType for the url that
        is going to be replaced if a cta is clicked*/ const queryParamsOfInterest = swcHelpers.objectSpread({}, queryParams, {
            linkedAppointmentTypeId: undefined,
            alternativeLinkedAppointmentTypeId: undefined
        });
        let urlToBeReplacedForLinkedAppointmentType = '';
        let urlToBeReplacedForAlternativeAppointmentType = '';
        /* we replace typeId with typeId based on which CTA the user clicks, we
        still have the value in original queryParams object */ if (linkedAppointmentTypeIdIsAvailable1) {
            queryParamsOfInterest.typeId = queryParams.linkedAppointmentTypeId;
            urlToBeReplacedForLinkedAppointmentType = `${basePath}/${currentRoute}${QueryString.stringify(queryParamsOfInterest)}`;
        }
        if (alternativeAppointmentTypeIdIsAvailable1) {
            queryParamsOfInterest.typeId = queryParams.alternativeLinkedAppointmentTypeId;
            urlToBeReplacedForAlternativeAppointmentType = `${basePath}/${currentRoute}${QueryString.stringify(queryParamsOfInterest)}`;
        }
        return {
            urlToBeReplacedForLinkedAppointmentType,
            urlToBeReplacedForAlternativeAppointmentType
        };
    }, [
        linkedAppointmentTypeIdIsAvailable1,
        alternativeAppointmentTypeIdIsAvailable1,
        queryParams,
        basePath,
        currentRoute, 
    ]);
    const labels = React.useMemo(()=>({
            linkedAppointmentTitle: getLabel('appointments.component.linkedAppointmentInfo.title'),
            linkedAppointmentCta: getLabel('appointments.component.linkedAppointmentInfo.cta'),
            alternativeAppointmentTitle: getLabel('appointments.component.alternativeAppointmentInfo.title'),
            alternativeAppointmentCta: getLabel('appointments.component.alternativeAppointmentInfo.cta')
        })
    , [
        getLabel
    ]);
    if (!linkedAppointmentTypeIdIsAvailable1 && !alternativeAppointmentTypeIdIsAvailable1) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(LinkedAppointmentInfo$1, swcHelpers.extends({}, {
        labels,
        className,
        linkedAppointmentTypeIdIsAvailable: linkedAppointmentTypeIdIsAvailable1,
        alternativeAppointmentTypeIdIsAvailable: alternativeAppointmentTypeIdIsAvailable1
    }, {
        linkedAppointmentCtaUrl: urlToBeReplacedForLinkedAppointmentType1,
        alternativeAppointmentCtaUrl: urlToBeReplacedForAlternativeAppointmentType1
    }, rest));
};
var LinkedAppointmentInfo = AppointmentInfoContainer;

export { LinkedAppointmentInfo as default };
//# sourceMappingURL=LinkedAppointmentInfoContainer.js.map
